import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Select, Spin, Switch } from "antd";

import { roleAndPermissionService, teamsService, userService } from "./../../redux/services";

import { UIDrawerForm, UIFormSection, UISwitchField, UIUpload } from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Edit extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading        : true,
			isSending        : false,
			canSelectAllTeams: false,
			roles            : [],
			rolesSelected    : [],
			teams            : [],
			teamsIsLoadind   : false,
			teamsPage        : 1,
			teamsSearch      : '',
			teamsHasMore     : false,
			selectedTeams    : [],
			uuid             : 0,
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid     : uuid,
		});

		let item;

		userService.show({uuid})
		.then((response) => {
			item = response.data.data;

			return roleAndPermissionService.getAutocomplete({
				orderBy: "is_system:desc|name:asc",
			});
		})
		.then((response) => {
			this.setState({
				isLoading: false,
				roles    : response.data.data,
			}, () => {
				// Fill form
				this.fillForm(item);
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});

		this.fetchTeams();
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			name     : data.name,
			email    : data.email,
			is_active: data.is_active,
			teams    : Array.isArray(data.equipes) ? data.equipes.map(item => item.uuid) : [],
		});

		if( data.avatar )
		{
			this.upload.setFiles([{
				uuid: data.uuid,
				url : data.avatar,
				type: 'image/jpeg',
			}]);
		}

		this.setState({
			rolesSelected: data.roles.map(role => role.uuid),
			selectedTeams: Array.isArray(data.equipes) ? data.equipes : [],
		});
	};

	resetFields = () => {
		this.form.resetFields();
		this.upload && this.upload.reset();

		this.setState({
			roles        : [],
			rolesSelected: [],
			selectedTeams: [],
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		const {uuid, rolesSelected} = this.state;

		if( !rolesSelected.length )
		{
			Modal.error({
				title  : "Ocorreu um erro!",
				content: "Selecione pelo menos um papél.",
			});

			return false;
		}

		this.setState({
			isSending: true,
		});

		const data = {...values};

		// uuid
		data.uuid = uuid;

		// Roles
		data.roles = rolesSelected;

		const file = this.upload.getFiles();

		// Foto existente (com uuid) não é reenviada
		if( file.files.length )
		{
			if( !file.files[0].uuid )
			{
				data.avatar = file.files[0];
			}
		}
		else
		{
			data.avatar = null;
		}

		userService.edit(data)
		.then((response) => {
			this.setState({
				isSending: false,
			});

			// Reset fields
			this.resetFields();

			// Success message
			message.success("Registro atualizado com sucesso.");

			// Callback
			this.props.onComplete();
		})
		.catch((data) => {
			this.setState({
				isSending: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onChangeRole = (uuid, checked) => {
		const {rolesSelected} = this.state;

		let newRolesSelected = [...rolesSelected];
		const indexSelected  = newRolesSelected.indexOf(uuid);

		if( checked )
		{
			if( indexSelected === -1 )
			{
				newRolesSelected.push(uuid);
			}
		}
		else
		{
			if( indexSelected !== -1 )
			{
				newRolesSelected.splice(indexSelected, 1);
			}
		}

		this.setState({
			rolesSelected: newRolesSelected,
		});
	};

	fetchTeams = (search = '', page = 1) => {
		const limit = 20;

		const data = {
			ativo : 1,
			search: search,
			page  : page,
			limit : limit,
		};

		this.setState({
			teamsIsLoadind: true,
		});

		teamsService.getAll(data)
		.then((response) => {
			this.setState((prevState) => ({
				teams            : page === 1 ? response.data.data : [...prevState.teams, ...response.data.data],
				teamsIsLoadind   : false,
				teamsPage        : page,
				teamsSearch      : search,
				teamsHasMore     : (page * limit) < response.data.meta.total,
				canSelectAllTeams: response.data.pode_selecionar_todos,
			}));
		})
		.catch((data) => {
			this.setState({
				teamsIsLoadind: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onSearchTeams = (search) => {
		this.fetchTeams(search, 1);
	};

	onPopupScrollTeams = (e) => {
		const {teamsIsLoadind, teamsHasMore, teamsPage, teamsSearch} = this.state;

		const target = e.target;

		if( !teamsIsLoadind && teamsHasMore && (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) )
		{
			this.fetchTeams(teamsSearch, teamsPage + 1);
		}
	};

	renderRoles = () => {
		const {roles, rolesSelected} = this.state;

		if( !roles.length )
		{
			return <p className="byp-role-option-empty">Nenhum papel disponível.</p>
		}

		return roles.map((role, index) => {
			const isSelected = rolesSelected.indexOf(role.uuid) !== -1;

			return (
				<div
					key={index}
					className={`byp-role-option ${isSelected ? "byp-role-option-selected" : ""}`}
					onClick={() => this.onChangeRole(role.uuid, !isSelected)}>
					{/* O clique é da linha inteira; a caixa só mostra o estado */}
					<span className={`byp-role-option-check ${isSelected ? "byp-role-option-check-on" : ""}`}>
						{isSelected && <i className="fas fa-check" />}
					</span>
					<span className="byp-role-option-icon"><i className="fas fa-crown" /></span>
					<span className="byp-role-option-text">
						<span className="byp-role-option-name">{role.name}</span>
						{role.description && <span className="byp-role-option-description">{role.description}</span>}
					</span>
				</div>
			)
		});
	};

	render() {
		const {visible} = this.props;

		const {isLoading, isSending, roles, rolesSelected, teams, selectedTeams, teamsIsLoadind, canSelectAllTeams} = this.state;

		const isGestor = roles.some(role => rolesSelected.includes(role.uuid) && role.is_gestor);

		const teamOptions = [
			...selectedTeams.filter(selected => !teams.some(team => team.uuid === selected.uuid)),
			...teams,
		];

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-users" />}
				title="Editar usuário"
				subtitle="Atualize os dados e as permissões do usuário.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}>
					<UIFormSection
						icon={<i className="fal fa-user" />}
						title="Dados do usuário">
						<Row gutter={16}>
							<Col xs={24} md={6}>
								<UIUpload
									name="avatar"
									ref={el => this.upload = el}
									label="Avatar"
									labelError="Avatar"
									acceptedFiles={['jpg', 'jpeg', 'png']}
								/>
							</Col>
							<Col xs={24} md={18}>
								<Form.Item name="name" label="Nome" hasFeedback>
									<Input disabled />
								</Form.Item>
								<Form.Item name="email" label="E-mail" hasFeedback>
									<Input disabled />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<UISwitchField
									stacked
									title="Ativo"
									description="Usuário ativo no sistema.">
									<Form.Item name="is_active" valuePropName="checked" noStyle>
										<Switch />
									</Form.Item>
								</UISwitchField>
							</Col>
						</Row>
						{isGestor && (
							<Row gutter={16}>
								<Col xs={24}>
									<Form.Item name="teams" label="Fluxos de Aprovação" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
										<Select
											mode="multiple"
											optionFilterProp="children"
											filterOption={(input, option) =>
												(typeof option.children === "string"
													? option.children
													: option.children.props.children
												)
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
											}
											allowClear
											placeholder="Selecione o(s) fluxos de aprovação(s)"
											notFoundContent={teamsIsLoadind ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
											onSearch={this.onSearchTeams}
											onPopupScroll={this.onPopupScrollTeams}
											showSearch>
											{canSelectAllTeams && <Select.Option value="todos">Todos</Select.Option>}
											{teamOptions.map((item, index) => (
												<Select.Option key={index} value={item.uuid}>{item.nome}</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
							</Row>
						)}
					</UIFormSection>
					<UIFormSection
						icon={<i className="fal fa-crown" />}
						title="Papéis e Permissões"
						description="Defina o papel do usuário no sistema.">
						<div className="byp-role-options">
							{this.renderRoles()}
						</div>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Edit;
